import {
  getBrowserLanguage,
  getUrlForLang,
  getValidLangKey,
  getCurrentLangKey
} from 'ptz-i18n'
import { langs, defaultLangKey } from 'constants/languages'
import { navigate, withPrefix } from 'gatsby'

export const getCurrentLanguage = () => {
  if (typeof window !== 'undefined') {
    /* Always get the language from the url */
    const currentLang = getCurrentLangKey(langs, '', window.location.pathname) // Get Language from URL
    if (currentLang) {
      // Save user custom language to localStorage
      localStorage.setItem('language', currentLang)
      return currentLang
    }
    /* Get Language from browser and localStorage */
    // Current Browser Language
    let lang = getBrowserLanguage()
    // Convert 'en-US' to 'en'
    if (lang.indexOf('-') !== -1) lang = lang.split('-')[0]
    // Convert 'en-US' to 'en'
    if (lang.indexOf('_') !== -1) lang = lang.split('_')[0]
    // return userCustomLanguage or browserLanguage
    lang = localStorage.getItem('language') || lang
    return lang
  }
  return defaultLangKey
}

export const setLanguage = language => {
  if (typeof window !== 'undefined') {
    language = getValidLangKey(langs, defaultLangKey, language) // getValidLangKey
    localStorage.setItem('language', language) // Save user custom language to localStorage
    const path = window.location.pathname // Get current pathName of url
    const langRegex = /^\/([\w]{2})\//g // Regex : /vi/pricing => [/vi/]pricing
    const pathWithoutLang = langRegex.test(path) ? path.split(langRegex)[2] : ''
    const newUrl = getUrlForLang('/', `/${pathWithoutLang}`, language)
    navigate(newUrl, { replace: true })
  }
}

// Check page with language prefix
export const isPageWithLanguage = pathName => {
  if (typeof window !== 'undefined') {
    const { pathname } = window.location
    const currentLang = getCurrentLangKey(langs, '', pathname)
    if (!currentLang) {
      navigate(withPrefix(`/${getCurrentLanguage()}/${pathname}`), {
        replace: true
      })
      return false
    }
    return true
  }
  return false
}
